import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { installChunkReloadHandler } from './utils/chunkReload';

// Self-heal stale code-split chunks after a deploy — visitors see a brief
// "Updating…" overlay + auto-refresh instead of an error page.
installChunkReloadHandler();

// The static SEO fallback tags in index.html exist only for crawlers that
// don't execute JS. Once the app runs, react-helmet-async emits the real
// per-route tags (marked data-rh) — remove the static ones so pages never
// carry two descriptions / og:title sets.
document
  .querySelectorAll(
    'meta[name="description"]:not([data-rh]), meta[property^="og:"]:not([data-rh]), meta[name^="twitter:"]:not([data-rh])'
  )
  .forEach((el) => el.remove());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
